import api from './api';

export default {
    async order(payload, token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`,
            };
            const response = await api.post(`/service/run`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
                console.error('Erro ao fazer request order run:', error);
                throw error;
        }
    },
    async getListOrders(token) {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`,
            };
            const response = await api.get(`/service/orders`, { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer request list orders:', error);
            throw error;
        }
    },
    async getOrderByCrews(token) {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`,
            };
            const response = await api.get(`/service/crews/orders`, { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer request get order by crews:', error);
            throw error;
        }
    },
    async getOrderLogs(orderId, token) {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`,
            };
            const response = await api.get(`/service/logs/${orderId}`, { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer request get order logs:', error);
            throw error;
        }
    },

    async setOrderFavorite(orderData, token) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            };
            const response = await api.post('/service/orders/favorite', orderData, { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer request set order as favorite:', error);
            throw error;
        }
    },

    async getFavoriteOrders(token) {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`,
            };
            const response = await api.get('/service/orders/favorite', { headers });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer request get favorite orders:', error);
            throw error;
        }
    },
}

